import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from './applyForm.vue';
import handleDialog from './components/handleDialog.vue';
import ticketForm from './ticketForm.vue';
import ticketHandleDialog from './components/ticketHandleDialog.vue';
import ticketFollowUpDialog from './components/ticketFollowUpDialog.vue';
import ticketAssignDialog from './components/ticketAssignDialog.vue';
import FollowUpDialog from './components/FollowUpDialog.vue';
import AddCardDialog from './components/AddCardDialog.vue';
import BiddingStatusDialog from './components/biddingStatusDialog.vue';
import PrintingStatusDialog from './components/printingStatusDialog.vue';
import BiddingResultDialog from './components/biddingResultDialog.vue';
import BiddingDeliveryDialog from './components/biddingDeliveryDialog.vue';
import CreatePrintingRecord from '@/views/salesCardManagement/createPrintingRecord.vue';
import printWorkOrder from './components/printWorkOrder.vue';
import cardCommonConfig from '@/views/order/cardCommonConfig.vue';
import saleOrderList from './components/saleOrderList.vue';
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { addVirtualOrder, getAllToDoProjectList, getAllToDoTaskList, getAllToDoMallList, getAllToDoBiddingList, getAllToDoPrintingList, getAllToDoPrintingExcel, getAllToDoProjectExcel, getProjectDeliveryHandleUser, searchUserList, getProjectTicketSelect, getProjectTicketAllToDoList, getAllToDoQuotationList, getSaleProjectDeliveryOrders } from '../api';
import { getAllToDoDefaultStatus, getTaskStatusOptionsCached } from './defaultForms';
import { decodeQueryData, mergeQueryData } from './deepLink';
export default {
  components: {
    applyForm: applyForm,
    handleDialog: handleDialog,
    ticketForm: ticketForm,
    ticketHandleDialog: ticketHandleDialog,
    ticketFollowUpDialog: ticketFollowUpDialog,
    ticketAssignDialog: ticketAssignDialog,
    FollowUpDialog: FollowUpDialog,
    AddCardDialog: AddCardDialog,
    BiddingStatusDialog: BiddingStatusDialog,
    PrintingStatusDialog: PrintingStatusDialog,
    BiddingResultDialog: BiddingResultDialog,
    BiddingDeliveryDialog: BiddingDeliveryDialog,
    CreatePrintingRecord: CreatePrintingRecord,
    printWorkOrder: printWorkOrder,
    cardCommonConfig: cardCommonConfig,
    saleOrderList: saleOrderList
  },
  props: {
    allProjectCount: {
      type: Number,
      default: 0
    },
    allTaskCount: {
      type: Number,
      default: 0
    },
    allToDoMallCount: {
      type: Number,
      default: 0
    },
    allToDoBiddingCount: {
      type: Number,
      default: 0
    },
    allToDoPrintingCount: {
      type: Number,
      default: 0
    },
    allToDoTicketCount: {
      type: Number,
      default: 0
    },
    allToDoQuotationCount: {
      type: Number,
      default: 0
    },
    allToDoCardPrintCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tabActiveName: '1',
      cardRuleDrawerVisible: false,
      cardRuleTrendParams: {},
      cardRuleLoadingId: null,
      cardRuleKind: '',
      followUpVisible: false,
      followUpProjectId: null,
      followUpTaskId: null,
      printingRecordDrawer: {
        visible: false,
        params: {}
      },
      companyList: [],
      decorationPersonList: [],
      printingPersonList: [],
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      searchForm: {
        number: '',
        item_number: '',
        user_id: null,
        status: [100, 200],
        type_of_demand: [],
        need_printing: null,
        expedited_not: null,
        urgent_printing: null,
        estimated_amount_start: '',
        estimated_amount_end: '',
        card_make: [],
        card_make_print: [],
        design_complexity: [],
        customer_id: null,
        project_name: '',
        project_type: [],
        type: [],
        person_charge_id: [],
        task_person_charge_id: null,
        bid_files: null,
        created_start: '',
        created_end: '',
        start_updated_at: '',
        end_updated_at: '',
        pageSize: 20,
        page: 1
      },
      createdAtTime: [],
      updatedAtTime: [],
      projectCreatedAtTime: [],
      taskCreatedAtTime: [],
      mallCreatedAtTime: [],
      biddingCreatedAtTime: [],
      quotationCreatedAtTime: [],
      taskStatusOptions: [],
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      drawerTitle: '装修&项目交付申请',
      addCardChannelName: '',
      // second_category_id 为 cascader 多选格式（数组的数组：[一级id, 二级id]），查询时取叶子 id
      ticketSearchForm: {
        work_order_no: '',
        title: '',
        second_category_id: [],
        item: '',
        status: [20],
        start_created_at: '',
        end_created_at: '',
        handler_id: null,
        page: 1,
        pageSize: 20
      },
      ticketCreatedAtTime: [],
      ticketListData: [],
      ticketListPages: {
        currentPage: 1,
        totalCount: 0
      },
      ticketCategoryTree: [],
      ticketDrawerVisible: false,
      ticketFormId: null,
      ticketFormType: 'view',
      ticketFormCustomerName: '',
      ticketHandleVisible: false,
      ticketFollowUpVisible: false,
      ticketAssignVisible: false,
      quotationSearchForm: {
        number: '',
        item_number: '',
        status: [100],
        user_id: '',
        task_person_charge_id: null,
        customer_id: null,
        project_name: '',
        project_type: [],
        created_start: '',
        created_end: '',
        pageSize: 20,
        page: 1
      },
      quotationListData: [],
      quotationListPages: {
        currentPage: 1,
        totalCount: 0
      },
      saleOrderList: [],
      orderSummary: {},
      orderListVisible: false,
      orderListLoading: false,
      orderListPages: {
        currentPage: 1,
        totalCount: 0
      },
      viewOrderRow: null
    };
  },
  computed: {
    // 将 allToDo 的 tab 值归一化为 applyForm 期望的 fromTab 值
    // allToDo tab: 1项目列表 2全部任务列表 3商城装修 4投标支持 5定制设计及印刷 7报价单配置
    // applyForm fromTab: 1项目列表 2商城装修 3投标支持 4定制设计及印刷 6报价单
    normalizedFromTab: function normalizedFromTab() {
      var map = {
        1: '1',
        2: '',
        3: '2',
        4: '3',
        5: '4',
        7: '6'
      };
      return map[this.tabActiveName] || '';
    },
    // 项目列表导出仅对全部待办管理员开放；两个入口页的权限前缀不同
    canExportProjectList: function canExportProjectList() {
      return this.$hasBtnRoles('/user/project-delivery/all-to-do') || this.$hasBtnRoles('/orders/project-delivery/all-to-do');
    }
  },
  created: function created() {
    var _this = this;
    var tabList = [{
      name: '1',
      permission: '/user/project-delivery/all-project-list'
    }, {
      name: '2',
      permission: '/user/project-delivery/all-task-list'
    }, {
      name: '3',
      permission: '/user/project-delivery/all-to-do-mall'
    }, {
      name: '4',
      permission: '/user/project-delivery/all-to-do-bidding'
    }, {
      name: '5',
      permission: '/user/project-delivery/all-to-do-printing'
    }, {
      name: '6',
      permission: '/user/project-ticket/all-to-do'
    }, {
      name: '7',
      permission: '/user/project-delivery/all-to-do-quotation'
    }];
    var firstVisibleTab = tabList.find(function (item) {
      return _this.$hasBtnRoles(item.permission);
    });
    if (!firstVisibleTab) return;
    this.tabActiveName = firstVisibleTab.name;
    // 深链兼容处理（备注：兼容期保留，后续随旧入口下线移除）：
    var isListAction = this.$route.query.action === 'list';
    if (isListAction) {
      var childTab = this.$route.query.childTab || '5';
      if (this.$hasBtnRoles('/user/project-delivery/all-to-do-printing')) {
        this.tabActiveName = childTab;
      }
      this.searchForm.status = this.getDefaultStatus(this.tabActiveName);
      mergeQueryData(this.searchForm, decodeQueryData(this.$route.query.queryData));
    } else {
      this.searchForm.status = this.getDefaultStatus(this.tabActiveName);
    }
    this.getCompanyList();
    if (this.tabActiveName === '2') {
      this.ensureTaskStatusOptions().then(function () {
        _this.searchForm.status = _this.getDefaultStatus('2');
        _this.getlist();
      });
    } else {
      this.ensureTaskStatusOptions();
      this.getlist();
    }
    if (this.tabActiveName === '6') {
      this.initTicketTab();
    }
    if (this.tabActiveName === '7') {
      this.getQuotationList();
    }
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      var query = _objectSpread({}, this.$route.query);
      delete query.id;
      this.$router.replace({
        query: query
      });
      // 旧深链（无 action 或 action=detail）：打开详情抽屉（兼容保留，观察期后随旧入口下线移除）
      if (!isListAction) {
        this.selectedId = id;
        this.selectedProjectType = this.$route.query.project_type;
        this.selectedProjectStatus = this.$route.query.status;
        this.applyFormType = 'view';
        this.applyFormVisible = true;
      }
    }
    this.getDecorationPersonList();
    this.getPrintingPersonList();
    // 初始预载人员下拉默认选项（空关键词返回默认列表）
    this.searchSubmitter('');
    this.searchPersonCharge('');
    this.searchBiddingPerson('');
    this.searchTicketHandler('');
    this.searchQuotationSubmitter('');
    this.searchQuotationCharge('');
  },
  methods: {
    // 卡规则保存/交付信息保存后关闭抽屉并刷新列表状态
    handleCardRuleSuccess: function handleCardRuleSuccess() {
      this.cardRuleDrawerVisible = false;
    },
    // 关闭抽屉时刷新报价单配置列表与角标（交付信息保存会联动任务状态）
    handleCardRuleDrawerClose: function handleCardRuleDrawerClose() {
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: 'quotation',
        searchForm: null
      });
    },
    // 首次点击由后端创建虚拟订单，用返回的订单号打开卡规则
    openCardRuleDrawer: function openCardRuleDrawer(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, orderId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this2.cardRuleLoadingId = row.id;
              _context.p = 1;
              _context.n = 2;
              return addVirtualOrder({
                sale_project_delivery_id: row.project_delivery_id
              });
            case 2:
              res = _context.v;
              orderId = res.data && res.data.order_id;
              if (orderId) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              // 功能菜单描述：1 通用卡规则走标准卡规则（功能菜单/基本规则只读），其余按个性化处理
              _this2.cardRuleKind = String(row.description) === '1' ? 'standard' : '';
              _this2.cardRuleTrendParams = {
                order_id: orderId,
                cardBinGroupId: '',
                bin_id: res.data && res.data.bin_id || '',
                flag: 'order',
                // 订单入口
                menuType: 'orderDetails',
                entryType: 'orderManage',
                premium_price: ''
              };
              _this2.cardRuleDrawerVisible = true;
            case 4:
              _context.p = 4;
              _this2.cardRuleLoadingId = null;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    },
    // 报价单订单列表（查看订单弹窗，含分页）
    fetchSaleOrders: function fetchSaleOrders(row) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref, _ref$page, page, _ref$pageSize, pageSize, res, data, pages;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? 20 : _ref$pageSize;
              _context2.n = 1;
              return getSaleProjectDeliveryOrders({
                sale_project_delivery_id: row.project_delivery_id,
                page: page,
                pageSize: pageSize
              });
            case 1:
              res = _context2.v;
              data = res.data || {};
              _this3.saleOrderList = data.list || [];
              _this3.orderSummary = {
                quotation: data.sale_project_delivery_quotation_money,
                used: data.total_order_money,
                available: data.available_money
              };
              pages = data.pages || {};
              _this3.orderListPages = {
                currentPage: pages.currentPage || page,
                totalCount: pages.totalCount !== undefined ? pages.totalCount : _this3.saleOrderList.length
              };
              return _context2.a(2, _this3.saleOrderList);
          }
        }, _callee2);
      }))();
    },
    viewOrderList: function viewOrderList(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this4.orderListLoading = true;
              _context3.p = 1;
              _this4.viewOrderRow = row;
              _context3.n = 2;
              return _this4.fetchSaleOrders(row);
            case 2:
              _this4.orderListVisible = true;
            case 3:
              _context3.p = 3;
              _this4.orderListLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    handleViewOrderPageChange: function handleViewOrderPageChange(page) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (_this5.viewOrderRow) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _this5.orderListLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return _this5.fetchSaleOrders(_this5.viewOrderRow, {
                page: page
              });
            case 3:
              _context4.p = 3;
              _this5.orderListLoading = false;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[2,, 3, 4]]);
      }))();
    },
    goOrderDetail: function goOrderDetail(row) {
      var src = "".concat(this.$store.state.user.domainName, "/#/order/orderDetails?order_id=").concat(row.id);
      window.open(src, '_blank');
    },
    // 侧滑打开【创建印刷单】—— 参数 schema 后续定义
    openPrintingRecordDrawer: function openPrintingRecordDrawer(params) {
      this.printingRecordDrawer.params = {
        id: params.card_make_print_id === '0' ? '' : params.card_make_print_id,
        batch: params.batch || '',
        type: params.card_make_print_id === '0' ? 'add' : 'edit',
        project_id: params.project_id || '',
        item_id: params.item_id || '',
        from: 'project',
        is_make_card: '0',
        is_getApi: '1'
      };
      this.printingRecordDrawer.visible = true;
    },
    handlePrintingRecordSuccess: function handlePrintingRecordSuccess() {
      this.printingRecordDrawer.visible = false;
      this.getlist();
    },
    // 印刷单列：制卡/印刷ID 带点击类型，点击后分别打开添加制卡弹窗、印刷单抽屉
    getPrintingSheetValues: function getPrintingSheetValues(row) {
      var values = [];
      if (Number(row.expedited_not) === 2) values.push({
        text: '加急设计'
      });
      if (Number(row.need_printing) === 1) {
        values.push({
          text: Number(row.urgent_printing) === 2 ? '需要印刷-加急' : '需要印刷'
        });
      } else if (Number(row.need_printing) === 2) {
        values.push({
          text: '不需要印刷'
        });
      }
      if (Number(row.printing_quantity) > 0) {
        values.push({
          text: "\u6570\u91CF\uFF1A".concat(row.printing_quantity)
        });
      }
      if (row.card_make_batch) {
        values.push({
          label: '制卡：',
          value: row.card_make_batch,
          type: 'card'
        });
      }
      if (row.card_make_print_id && String(row.card_make_print_id) !== '0') {
        values.push({
          label: '印刷ID：',
          value: row.card_make_print_id,
          type: 'print'
        });
      }
      return values;
    },
    handlePrintingSheetClick: function handlePrintingSheetClick(row, type) {
      if (type === 'card') {
        this.handleAddCard(row);
        return;
      }
      this.openPrintingRecordDrawer(row);
    },
    handleTabClick: function handleTabClick(tab) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(tab.name === _this6.tabActiveName)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _this6.tabActiveName = tab.name;
              if (!(tab.name === '6')) {
                _context5.n = 2;
                break;
              }
              _this6.initTicketTab();
              _this6.$emit('countChange', {
                tabKey: 'ticket',
                searchForm: null
              });
              return _context5.a(2);
            case 2:
              if (!(tab.name === '7')) {
                _context5.n = 3;
                break;
              }
              _this6.quotationSearchForm = {
                number: '',
                item_number: '',
                status: [100],
                user_id: '',
                task_person_charge_id: null,
                customer_id: null,
                project_name: '',
                project_type: [],
                created_start: '',
                created_end: '',
                pageSize: 20,
                page: 1
              };
              _this6.quotationCreatedAtTime = [];
              _this6.getQuotationList();
              _this6.$emit('countChange', {
                tabKey: 'quotation',
                searchForm: null
              });
              return _context5.a(2);
            case 3:
              _this6.searchForm.number = '';
              _this6.searchForm.item_number = '';
              _this6.searchForm.user_id = null;
              _context5.n = 4;
              return _this6.ensureTaskStatusOptions();
            case 4:
              _this6.searchForm.status = _this6.getDefaultStatus(tab.name);
              _this6.searchForm.type_of_demand = [];
              _this6.searchForm.need_printing = null;
              _this6.searchForm.expedited_not = null;
              _this6.searchForm.urgent_printing = null;
              _this6.searchForm.estimated_amount_start = '';
              _this6.searchForm.estimated_amount_end = '';
              _this6.searchForm.card_make = [];
              _this6.searchForm.card_make_print = [];
              _this6.searchForm.design_complexity = [];
              _this6.searchForm.customer_id = null;
              _this6.searchForm.project_name = '';
              _this6.searchForm.project_type = [];
              _this6.searchForm.type = [];
              _this6.searchForm.person_charge_id = [];
              _this6.searchForm.task_person_charge_id = null;
              _this6.searchForm.bid_files = null;
              _this6.searchForm.created_start = '';
              _this6.searchForm.created_end = '';
              _this6.searchForm.start_updated_at = '';
              _this6.searchForm.end_updated_at = '';
              _this6.searchForm.pageSize = 20;
              _this6.searchForm.page = 1;
              _this6.createdAtTime = [];
              _this6.updatedAtTime = [];
              _this6.projectCreatedAtTime = [];
              _this6.taskCreatedAtTime = [];
              _this6.mallCreatedAtTime = [];
              _this6.biddingCreatedAtTime = [];
              _this6.getlist();
              _this6.$emit('countChange', {
                tabKey: _this6.getTabKey(tab.name),
                searchForm: null
              });
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getDefaultStatus: function getDefaultStatus(tabName) {
      return getAllToDoDefaultStatus(tabName, this.taskStatusOptions);
    },
    ensureTaskStatusOptions: function ensureTaskStatusOptions() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _t;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!_this7.taskStatusOptions.length) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _context6.p = 1;
              _context6.n = 2;
              return getTaskStatusOptionsCached();
            case 2:
              _this7.taskStatusOptions = _context6.v;
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t = _context6.v;
              _this7.taskStatusOptions = [];
            case 4:
              return _context6.a(2);
          }
        }, _callee6, null, [[1, 3]]);
      }))();
    },
    getTabKey: function getTabKey(tabName) {
      var map = {
        1: 'project',
        2: 'task',
        3: 'mall',
        4: 'bidding',
        5: 'card',
        6: 'ticket',
        7: 'quotation',
        8: 'card_make_print'
      };
      return map[tabName] || 'project';
    },
    // 印刷工单列表搜索联动角标：转发子组件上报的搜索参数，
    // 以 tabKey='card_make_print' 覆盖 all-to-do 计数参数，保持角标与列表一致
    handlePrintWorkOrderCountChange: function handlePrintWorkOrderCountChange(searchForm) {
      this.$emit('countChange', {
        tabKey: 'card_make_print',
        searchForm: searchForm
      });
    },
    getCompanyList: function getCompanyList(val) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context7.v;
              _this8.companyList = res.data.list;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              kw = (keyword || '').trim();
              _this9.personLoading = true;
              _context8.p = 1;
              _context8.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context8.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this9.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this9.personOptionCache[String(id)];
              }).filter(Boolean);
              _this9.$set(_this9.personOptions, field, picked.concat(list));
            case 3:
              _context8.p = 3;
              _this9.personLoading = false;
              return _context8.f(3);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, null, [[1,, 3, 4]]);
      }))();
    },
    // 提交人（列表筛选）
    searchSubmitter: function searchSubmitter(keyword) {
      var _this0 = this;
      return this.searchPerson(keyword, 'submitter', function () {
        return _this0.searchForm.user_id;
      });
    },
    getDecorationPersonList: function getDecorationPersonList() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return getProjectDeliveryHandleUser({
                type: 3
              });
            case 1:
              res = _context9.v;
              _this1.decorationPersonList = res.data.list || [];
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getPrintingPersonList: function getPrintingPersonList() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return getProjectDeliveryHandleUser({
                type: 5,
                item_name: '设计师'
              });
            case 1:
              res = _context0.v;
              _this10.printingPersonList = res.data.list || [];
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    // 负责人（全部任务列表）
    searchPersonCharge: function searchPersonCharge(keyword) {
      var _this11 = this;
      return this.searchPerson(keyword, 'f20', function () {
        return _this11.searchForm.person_charge_id;
      });
    },
    // 投标负责人（投标支持列表）
    searchBiddingPerson: function searchBiddingPerson(keyword) {
      var _this12 = this;
      return this.searchPerson(keyword, 'f22', function () {
        return _this12.searchForm.task_person_charge_id;
      });
    },
    // 处理人（咨询工单）
    searchTicketHandler: function searchTicketHandler(keyword) {
      var _this13 = this;
      return this.searchPerson(keyword, 'ticketHandler', function () {
        return _this13.ticketSearchForm.handler_id;
      });
    },
    // 提交人（报价单配置）
    searchQuotationSubmitter: function searchQuotationSubmitter(keyword) {
      var _this14 = this;
      return this.searchPerson(keyword, 'quotationSubmitter', function () {
        return _this14.quotationSearchForm.user_id;
      });
    },
    // 报价单负责人（报价单配置）
    searchQuotationCharge: function searchQuotationCharge(keyword) {
      var _this15 = this;
      return this.searchPerson(keyword, 'quotationCharge', function () {
        return _this15.quotationSearchForm.task_person_charge_id;
      });
    },
    getlist: function getlist() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var apiFn, res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!['6', '7', '8'].includes(_this16.tabActiveName)) {
                _context1.n = 1;
                break;
              }
              _this16.listData = [];
              _this16.listPages = {
                currentPage: 1,
                totalCount: 0
              };
              return _context1.a(2);
            case 1:
              apiFn = getAllToDoProjectList;
              if (_this16.tabActiveName === '1') {
                apiFn = getAllToDoProjectList;
              } else if (_this16.tabActiveName === '2') {
                apiFn = getAllToDoTaskList;
              } else if (_this16.tabActiveName === '3') {
                apiFn = getAllToDoMallList;
              } else if (_this16.tabActiveName === '4') {
                apiFn = getAllToDoBiddingList;
              } else if (_this16.tabActiveName === '5') {
                apiFn = getAllToDoPrintingList;
              }
              _context1.n = 2;
              return apiFn(_this16.searchForm);
            case 2:
              res = _context1.v;
              _this16.listData = res.data.data;
              _this16.listPages = res.pages;
            case 3:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    initTicketTab: function initTicketTab() {
      if (!this.ticketCategoryTree.length) {
        this.getTicketCategoryTree();
      }
      this.getTicketList();
    },
    // 跟进提交成功：报价单配置列表数据独立，需按 tab 选择刷新目标
    handleFollowUpSuccess: function handleFollowUpSuccess() {
      if (this.tabActiveName === '7') {
        this.getQuotationList();
      } else {
        this.getlist();
      }
    },
    // 报价单配置列表
    getQuotationList: function getQuotationList() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return getAllToDoQuotationList(_this17.quotationSearchForm);
            case 1:
              res = _context10.v;
              _this17.quotationListData = res.data && res.data.data || [];
              _this17.quotationListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    quotationResetList: function quotationResetList() {
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
      this.$emit('countChange', {
        tabKey: 'quotation',
        searchForm: _objectSpread({}, this.quotationSearchForm)
      });
    },
    handleQuotationPageChange: function handleQuotationPageChange(page) {
      this.quotationSearchForm.page = page;
      this.getQuotationList();
      var dom = document.getElementById('quotationSearchDom');
      dom && dom.scrollIntoView();
    },
    quotationSizeChange: function quotationSizeChange(size) {
      this.quotationSearchForm.pageSize = size;
      this.quotationSearchForm.page = 1;
      this.getQuotationList();
    },
    getTicketCategoryTree: function getTicketCategoryTree() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context11.v;
              _this18.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    getTicketList: function getTicketList() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var secondCategoryIds, res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              // cascader 多选值为路径数组（[一级id, 二级id]），接口需要叶子（二级）id 数组
              secondCategoryIds = _this19.ticketSearchForm.second_category_id.map(function (path) {
                return path.length ? path[path.length - 1] : null;
              });
              _context12.n = 1;
              return getProjectTicketAllToDoList({
                work_order_no: _this19.ticketSearchForm.work_order_no,
                title: _this19.ticketSearchForm.title,
                second_category_id: secondCategoryIds,
                item: _this19.ticketSearchForm.item,
                status: _this19.ticketSearchForm.status,
                start_created_at: _this19.ticketSearchForm.start_created_at,
                end_created_at: _this19.ticketSearchForm.end_created_at,
                handler_id: _this19.ticketSearchForm.handler_id,
                page: _this19.ticketSearchForm.page,
                pageSize: _this19.ticketSearchForm.pageSize
              });
            case 1:
              res = _context12.v;
              _this19.ticketListData = res.data.data || [];
              _this19.ticketListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    ticketResetList: function ticketResetList() {
      this.ticketSearchForm.page = 1;
      this.getTicketList();
      this.emitTicketCountChange();
    },
    // 咨询工单搜索后联动角标：cascader 取叶子节点 id，与列表请求口径一致
    emitTicketCountChange: function emitTicketCountChange() {
      var secondCategoryIds = this.ticketSearchForm.second_category_id.map(function (path) {
        return path.length ? path[path.length - 1] : null;
      });
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: {
          work_order_no: this.ticketSearchForm.work_order_no,
          title: this.ticketSearchForm.title,
          second_category_id: secondCategoryIds,
          item: this.ticketSearchForm.item,
          status: this.ticketSearchForm.status,
          start_created_at: this.ticketSearchForm.start_created_at,
          end_created_at: this.ticketSearchForm.end_created_at,
          handler_id: this.ticketSearchForm.handler_id,
          page: 1,
          pageSize: this.ticketSearchForm.pageSize
        }
      });
    },
    handleTicketPageChange: function handleTicketPageChange(page) {
      this.ticketSearchForm.page = page;
      this.getTicketList();
      var dom = document.getElementById('ticketSearchDom');
      dom.scrollIntoView();
    },
    ticketSizeChange: function ticketSizeChange(size) {
      this.ticketSearchForm.pageSize = size;
      this.ticketSearchForm.page = 1;
      this.getTicketList();
    },
    changeTicketCreatedAtTime: function changeTicketCreatedAtTime(val) {
      this.ticketSearchForm.start_created_at = val ? val[0] : '';
      this.ticketSearchForm.end_created_at = val ? val[1] : '';
    },
    viewTicketDetail: function viewTicketDetail(row) {
      this.ticketFormId = row.id;
      this.ticketFormType = 'view';
      this.ticketFormCustomerName = row.customer_info && row.customer_info.company_name || '';
      this.ticketDrawerVisible = true;
    },
    openTicketHandle: function openTicketHandle(row) {
      this.$refs.ticketHandleDialog.open(row.id);
    },
    openTicketFollowUp: function openTicketFollowUp(row) {
      this.$refs.ticketFollowUpDialog.open(row.id);
    },
    openTicketAssign: function openTicketAssign(row) {
      this.$refs.ticketAssignDialog.open(row.id);
    },
    // 工单操作（处理/跟进/修改负责人）成功：刷新列表并联动顶部/子tab角标计数
    handleTicketActionSuccess: function handleTicketActionSuccess() {
      this.getTicketList();
      this.$emit('countChange', {
        tabKey: 'ticket',
        searchForm: null
      });
    },
    handleTicketFormSuccess: function handleTicketFormSuccess() {
      this.ticketDrawerVisible = false;
      this.getTicketList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.getlist();
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      // 订单预计金额：起始值不能大于结束值
      if (this.tabActiveName == '5' && this.searchForm.estimated_amount_start && this.searchForm.estimated_amount_end && Number(this.searchForm.estimated_amount_start) > Number(this.searchForm.estimated_amount_end)) {
        this.$message.warning('订单预计金额最小值不能大于最大值');
        return;
      }
      this.searchForm.page = 1;
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    handleClose: function handleClose() {
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    viewDetail: function viewDetail(row) {
      this.selectedId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = this.getProjectStatus(row);
      this.applyFormType = 'view';
      if (this.tabActiveName === '1') {
        this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      } else {
        this.drawerTitle = '装修&项目交付申请（任务ID：' + row.number + '）';
      }
      this.applyFormVisible = true;
    },
    handleProcess: function handleProcess(row) {
      this.$refs.handleDialog.openProcess(row.item_id);
    },
    handleProjectReview: function handleProjectReview(row) {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _this20.selectedId = row.id;
              _this20.selectedProjectType = row.project_type;
              _this20.selectedProjectStatus = _this20.getProjectStatus(row);
              _this20.applyFormType = 'projectReview';
              _this20.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
              _this20.applyFormVisible = true;
            case 1:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    getProjectStatus: function getProjectStatus(row) {
      return row.status;
    },
    handleBiddingProcess: function handleBiddingProcess(row) {
      this.$refs.handleDialog.openBidding(row.item_id);
    },
    handleDemandStatusClick: function handleDemandStatusClick(row, value) {
      if (value.type == 2) {
        this.handleBiddingStatusClick(row, value);
      } else if (value.type == 3) {
        this.handlePrintingStatusClick(row, value);
      }
    },
    handleBiddingStatusClick: function handleBiddingStatusClick(row, value) {
      if (value.type == 2) {
        this.$refs.biddingStatusDialog.open(row.item_id);
      }
    },
    handlePrintingStatusClick: function handlePrintingStatusClick(row, value) {
      if (value.type == 3 && (this.tabActiveName == '2' || this.tabActiveName == '5')) {
        this.$refs.printingStatusDialog.open(row.item_id);
      }
    },
    handleBiddingResultClick: function handleBiddingResultClick(row) {
      this.$refs.biddingResultDialog.open(row.item_id);
    },
    handleBiddingDeliveryClick: function handleBiddingDeliveryClick(row) {
      this.$refs.biddingDeliveryDialog.open(row.item_id);
    },
    handleTaskProcess: function handleTaskProcess(row) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!(row.type == '1')) {
                _context14.n = 2;
                break;
              }
              _context14.n = 1;
              return _this21.handleProcess(row);
            case 1:
              _context14.n = 5;
              break;
            case 2:
              if (!(row.type == '2')) {
                _context14.n = 4;
                break;
              }
              _context14.n = 3;
              return _this21.handleBiddingProcess(row);
            case 3:
              _context14.n = 5;
              break;
            case 4:
              if (!(row.type == '3')) {
                _context14.n = 5;
                break;
              }
              _context14.n = 5;
              return _this21.handleCardAndCouponDesignProcess(row);
            case 5:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    handleCardAndCouponDesignProcess: function handleCardAndCouponDesignProcess(row) {
      this.$refs.handleDialog.openCardAndCouponDesign(row.item_id);
    },
    handleProjectProcess: function handleProjectProcess(row) {
      this.$refs.handleDialog.openProject(row.id);
    },
    openFollowUp: function openFollowUp(row) {
      this.followUpProjectId = this.tabActiveName === '1' ? row.id : row.project_id;
      this.followUpTaskId = this.tabActiveName === '1' ? null : row.item_id;
      this.followUpVisible = true;
    },
    handleDialogSuccess: function handleDialogSuccess() {
      this.getlist();
      this.$emit('countChange', {
        tabKey: this.getTabKey(this.tabActiveName),
        searchForm: _objectSpread({}, this.searchForm)
      });
    },
    changeCreatedTime: function changeCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeUpdatedTime: function changeUpdatedTime(val) {
      this.searchForm.start_updated_at = val ? val[0] : '';
      this.searchForm.end_updated_at = val ? val[1] : '';
    },
    changeProjectCreatedTime: function changeProjectCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeTaskCreatedTime: function changeTaskCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeMallCreatedTime: function changeMallCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeBiddingCreatedTime: function changeBiddingCreatedTime(val) {
      this.searchForm.created_start = val ? val[0] : '';
      this.searchForm.created_end = val ? val[1] : '';
    },
    changeQuotationCreatedTime: function changeQuotationCreatedTime(val) {
      this.quotationSearchForm.created_start = val ? val[0] : '';
      this.quotationSearchForm.created_end = val ? val[1] : '';
    },
    // 定制设计及印刷：跟进记录首条高亮，其余历史条目调浅
    getFollowUpItemClass: function getFollowUpItemClass(index) {
      if (this.tabActiveName !== '5') return '';
      return index === 0 ? 'follow-up-first' : 'follow-up-muted';
    },
    exportPrinting: function exportPrinting() {
      var _this22 = this;
      getAllToDoPrintingExcel(_objectSpread({}, this.searchForm)).then(function (res) {
        if (res.data) {
          _this22.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      });
    },
    exportProjectList: function exportProjectList() {
      var _this23 = this;
      getAllToDoProjectExcel(_objectSpread({}, this.searchForm)).then(function (res) {
        if (res.data) {
          _this23.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      });
    },
    handleAddCard: function handleAddCard(row) {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var event;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              event = _this24.$refs.addCardDialog;
              event.open(row);
            case 1:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    handleAddCardSuccess: function handleAddCardSuccess() {
      // 按用户要求：只关闭弹框，不刷新
    }
  }
};